const compare = require('./compare')
const compareLoose = (a, b) => compare(a, b, true)
module.exports = compareLoose



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/compare-loose.js
// module id = 1919
// module chunks = 1